import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import addOPPlusSubscriptionAndRedirectToCartOperation from 'store/app/operation/addOPPlusSubscriptionAndRedirectToCartOperation';
import redirectToCartOperation from 'store/app/operation/redirectToCartOperation';
import getOPPlusContent from 'store/product/selector/getOPPlusContent';
import styles from './OPPlusOffer.module.scss';

const OPPlusOffer = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const OPPlus = useSelector(getOPPlusContent);

  if (!OPPlus || !OPPlus.displayUpsellPopup) {
    return null;
  }

  const addOPPlus = () => {
    dispatch(addOPPlusSubscriptionAndRedirectToCartOperation());
  };

  const goToCheckout = () => {
    dispatch(redirectToCartOperation());
  };

  return (
    <div className={styles.OPPlusOffer}>
      <div className={styles.title}>{t('txt_opplus_upsell_artprints_title', { logo: '' })}</div>
      <div className={styles.row}>{t('txt_opplus_upsell_artprints_description')}</div>
      <div className={styles.row}>
        <img src="/s/assets/images/general/op-plus/icons/op-plus-icon1.png" alt="" className={styles.opPlusImage} />
      </div>
      <div>
        <div className={styles.row}>
          {t('txt_opplus_upsell_estimated_delivery', { estimated_delivery: OPPlus.details?.txtEstimatedDelivery })}
        </div>
        <div className={styles.row}>
          {t('txt_opplus_upsell_membership_fee', { opplus_price: OPPlus.details?.txtPlusPrice })}
        </div>
      </div>
      <div className={styles.row}>
        {t('txt_opplus_upsell_membership_fee_savings', { price: OPPlus.details?.txtMembershipFee })}
      </div>
      <div className={styles.row}>
        <div className={styles.buttons}>
          <button id="checkout-with-op-plus-button" className={styles.addOPPlus} onClick={addOPPlus}>
            {t('txt_opplus_upsell_button_withPlus')}
          </button>
          <button id="checkout-button" className={styles.skipOPPlus} onClick={goToCheckout}>
            {t('txt_opplus_upsell_button_withoutPlus')}
          </button>
        </div>
      </div>
      <div className={styles.hint}>{t('txt_opplus_paymentterms')}</div>
    </div>
  );
};

export default OPPlusOffer;
